import type { ActoDetalle, Folio } from "@/lib/types";
import { LambdaFolioClient } from "./lambda";

export interface ActoRef {
  clave: string;
  control: string;
  consecutivo: string;
  fechaBoleta: string;
}

export interface FolioApiClient {
  getFolio(id: string): Promise<Folio | null>;
  getActoDetalle(folioId: string, ref: ActoRef): Promise<ActoDetalle | null>;
}

// Single client en el SPA: habla con los Lambdas via CloudFront (/api por default).
// El proxy de Vite redirige /api a BACKEND_PROXY_TARGET en dev.
const BACKEND_BASE =
  (import.meta.env.VITE_BACKEND_URL as string | undefined) ?? "/api";

let cached: FolioApiClient | null = null;

export function getClient(): FolioApiClient {
  if (!cached) cached = new LambdaFolioClient(BACKEND_BASE);
  return cached;
}

export const BACKEND_URL = BACKEND_BASE;
